import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=10146e04&scoped=true&"
import script from "./SettingsLayout.vue?vue&type=script&lang=js&"
export * from "./SettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=10146e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10146e04",
  null
  
)

export default component.exports